import { FormButton } from "../components/_input/_button";
import { SwiperSlide, Swiper } from 'swiper/react';
import { useTranslation } from "react-i18next";
import SwiperCore, { Pagination, Navigation, Autoplay, EffectFade } from "swiper";
import moment from "moment";
import SectionHeading from "../components/sectionHeading";
import CarUser from "./components/CarUser";

import useUserCars from "./hooks/useUserCars";

SwiperCore.use([Pagination, Navigation, Autoplay, EffectFade,]);
export default function UserVehicle({onUpdate,isLoadingUpdate,handlePopupCreate}) {
    const { t: trans, i18n } = useTranslation(["common", "inputs", "offers", "home", "eparts", "user", "info", "hints"]);
    const lang = (i18n.language || 'ar');
    const langaugeDir = 'language-' + lang;
    const dir = lang == 'en' ? 'left' : 'right';
    const { data: cars = [], isLoading, isError } = useUserCars();

    return (
        <div className={`${langaugeDir}`}>
            <FormButton isPrimary={true} classes={` px-5 py-2 nice-float-${dir} nice-width-init`} type='button' name={trans("user:add_new_vehicle")}
                onClick={() => handlePopupCreate(true)} />
            <div className="clear-both"></div>

            <div className="swiper-wrapper-grid-auto my-8">
                <SectionHeading
                    hasRuler={false}
                    infoText={trans("user:private_cars_note")}
                    title={trans("user:private_cars")}
                >
                    <Swiper
                        spaceBetween={0}
                        slidesPerView={1.3} // Shows one full item and a peek of the next for better proportions
                        breakpoints={{
                            480: {
                                slidesPerView: 1.8,
                            },
                            768: {
                                slidesPerView: 3.2,
                            },
                            1024: {
                                slidesPerView: 4,
                            },
                        }}
                        resizeObserver={"true"}
                        pagination
                        watchSlidesVisibility
                        watchSlidesProgress
                        autoplay={false}
                        loop={false}
                        observer={true}

                    >
                        {cars?.map((car, index) => {

                            return <SwiperSlide className={"px-3 my-3"} key={index}>
                                <CarUser
                                    onUpdate={(id, SN, fetchType) => onUpdate(id, SN, fetchType, car)}
                                    inputDate={car.InputDate ? moment(car.InputDate).format('YYYY-MM-DD') : ""}
                                    id={car.GUID}
                                    img={car.Image !== null ? car.Image : '/assets/images/parts/default.png'}
                                    name={car[`Model${trans('model:description')}`] ?? car[`Group${trans('model:description')}`]}
                                    brand={car[`Brand${trans('model:description')}`]}
                                    brandIcon={car.Icon ? "data:image/png;base64," + car.Icon : null}
                                    brandImage={car.IconImage ? car.IconImage : null}
                                    link={"/user/vehicles/privateVehicles/" + car.CarID + "/" + car.FetchType}
                                    topCardClassName={"h-auto-important"}
                                    userCarName={car?.alias}
                                    fetchType={car?.FetchType}
                                    SN={car?.CarID}
                                    isLoadingUpdateSN={isLoadingUpdate}
                                />

                            </SwiperSlide>
                        })}
                    </Swiper>
                </SectionHeading>
            </div>

        
        </div>
    );
}